import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DailySchedule = _resolveComponent("DailySchedule")!
  const _component_UnsetSchedule = _resolveComponent("UnsetSchedule")!
  const _component_ScheduleUserEditModal = _resolveComponent("ScheduleUserEditModal")!
  const _component_RentalContractModal = _resolveComponent("RentalContractModal")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (_ctx.isShow.render)
      ? (_openBlock(), _createBlock(_component_DailySchedule, {
          key: 0,
          "is-mobile": _ctx.isMobile
        }, null, 8, ["is-mobile"]))
      : _createCommentVNode("", true),
    (_ctx.isShow.render)
      ? (_openBlock(), _createBlock(_component_UnsetSchedule, {
          key: 1,
          "is-mobile": _ctx.isMobile
        }, null, 8, ["is-mobile"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ScheduleUserEditModal),
    _createVNode(_component_RentalContractModal)
  ], 512)), [
    [_vShow, _ctx.isShow.display]
  ])
}